import { render, staticRenderFns } from "./TemplatesArchiveButton.vue?vue&type=template&id=074c778e&scoped=true"
import script from "./TemplatesArchiveButton.vue?vue&type=script&lang=js"
export * from "./TemplatesArchiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c778e",
  null
  
)

export default component.exports